import { useEffect } from 'react';
import { useTranslation } from '@frontend/i18n';
import { DropdownFilterChipField, useFormField } from '@frontend/design-system';

export type SortFilterValue = 'NEXT_OCCURRENCE' | 'NAME';

type Props = {
  value: SortFilterValue;
  onChange: (value: SortFilterValue) => void;
};

export const SortFilter = ({ value, onChange }: Props) => {
  const { t } = useTranslation('schedule-settings');
  const checklistFieldProps = useFormField({ type: 'checklist', value: ['NEXT_OCCURRENCE'] });

  useEffect(() => {
    if (checklistFieldProps.value && checklistFieldProps.value[0] !== value) {
      onChange(checklistFieldProps.value[0] as SortFilterValue);
    }
  }, [checklistFieldProps.value, onChange, value]);

  return (
    <>
      <DropdownFilterChipField
        {...checklistFieldProps}
        label={t('Sort By')}
        name='rule-exceptions-sort-filter'
        showSearchBar={false}
        showSelectionBar={false}
        isSingleSelect
        icon={checklistFieldProps.value[0] === 'NEXT_OCCURRENCE' ? 'sort-descending' : 'sort-ascending'}
        getCustomLabel={(items) => t(`Sort By: {{name}}`, { name: items[0] })}
      >
        <DropdownFilterChipField.SingleSelectOption value='NEXT_OCCURRENCE'>
          {t('Next Occurring')}
        </DropdownFilterChipField.SingleSelectOption>
        <DropdownFilterChipField.SingleSelectOption value='NAME'>
          {t('Exception Name')}
        </DropdownFilterChipField.SingleSelectOption>
      </DropdownFilterChipField>
    </>
  );
};
